var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80088 3.86909C8.67873 3.99371 8.61031 4.16126 8.61031 4.33576C8.61031 4.51026 8.67873 4.67781 8.80088 4.80243L9.86755 5.86909C9.99217 5.99125 10.1597 6.05967 10.3342 6.05967C10.5087 6.05967 10.6763 5.99125 10.8009 5.86909L13.3142 3.35576C13.6494 4.09655 13.7509 4.92192 13.6052 5.72186C13.4594 6.5218 13.0734 7.25832 12.4984 7.83328C11.9234 8.40824 11.1869 8.79431 10.387 8.94007C9.58704 9.08582 8.76167 8.98432 8.02088 8.64909L3.41421 13.2558C3.149 13.521 2.78929 13.67 2.41421 13.67C2.03914 13.67 1.67943 13.521 1.41421 13.2558C1.149 12.9905 1 12.6308 1 12.2558C1 11.8807 1.149 11.521 1.41421 11.2558L6.02088 6.64909C5.68566 5.9083 5.58416 5.08294 5.72991 4.283C5.87566 3.48306 6.26174 2.74653 6.83669 2.17158C7.41165 1.59662 8.14818 1.21054 8.94812 1.06479C9.74806 0.919038 10.5734 1.02054 11.3142 1.35576L8.80088 3.86909Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/Tool.8fffa51cd7d56379ccc7086ad0a863fb.svg";
export { ForwardRef as ReactComponent };